import { PriceChannel } from '@retail/products/types';
import { LocationConfig } from './LocationConfig';
import { AssortmentConfigDTO } from '../dto';

export const availableTotalfileFrequencies = [
  'DAILY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
] as const;
export type TotalfilFrequency = (typeof availableTotalfileFrequencies)[number];

export const availableCharsets = ['utf-8', 'cp850', 'windows-1252'] as const;
export type Charsets = (typeof availableCharsets)[number];
interface AssortmentConfigProps {
  id: number;
  title: string;
  erpId?: string;
  erpType?: string;
  priceChannel?: PriceChannel;
  mgPrisVersion?: 'LIGHT' | 'FULL';
  sendSalesPriceUpdated: boolean;
  totalfilFormat?: 'CSV' | 'VILMA';
  totalfilCharset?: Charsets;
  totalfilPerSupplier?: boolean;
  totalfilToSftp?: boolean;
  totalfilSftpDirectory?: string;
  totalfilSftpFrequency?: TotalfilFrequency;
  totalfilNumberOfFutureDays?: number;
  totalfilVilmaVersion?: 'VILMA_27' | 'VILMA_28';
  locations: LocationConfig[];
}

export class AssortmentConfig {
  id: number;
  title: string;
  erpId?: string;
  erpType?: string;
  priceChannel?: PriceChannel;
  mgPrisVersion?: 'LIGHT' | 'FULL';
  sendSalesPriceUpdated: boolean;
  totalfilFormat?: 'CSV' | 'VILMA';
  totalfilCharset?: Charsets;
  totalfilPerSupplier?: boolean;
  totalfilToSftp?: boolean;
  totalfilSftpDirectory?: string;
  totalfilSftpFrequency?: TotalfilFrequency;
  totalfilNumberOfFutureDays?: number;
  totalfilVilmaVersion?: 'VILMA_27' | 'VILMA_28';
  locations: LocationConfig[];

  constructor({
    id,
    title,
    erpId,
    erpType,
    priceChannel,
    mgPrisVersion,
    sendSalesPriceUpdated,
    totalfilFormat,
    totalfilCharset,
    totalfilPerSupplier,
    totalfilToSftp,
    totalfilSftpDirectory,
    totalfilSftpFrequency,
    totalfilNumberOfFutureDays,
    totalfilVilmaVersion,
    locations,
  }: AssortmentConfigProps) {
    this.id = id;
    this.title = title;
    this.erpId = erpId;
    this.erpType = erpType;
    this.priceChannel = priceChannel;
    this.mgPrisVersion = mgPrisVersion;
    this.sendSalesPriceUpdated = sendSalesPriceUpdated;
    this.totalfilFormat = totalfilFormat;
    this.totalfilCharset = totalfilCharset;
    this.totalfilPerSupplier = totalfilPerSupplier;
    this.totalfilToSftp = totalfilToSftp;
    this.totalfilSftpDirectory = totalfilSftpDirectory;
    this.totalfilSftpFrequency = totalfilSftpFrequency;
    this.totalfilNumberOfFutureDays = totalfilNumberOfFutureDays;
    this.totalfilVilmaVersion = totalfilVilmaVersion;
    this.locations = locations;
  }

  static fromDto = (dto: AssortmentConfigDTO): AssortmentConfig =>
    new AssortmentConfig({
      id: dto.id,
      title: dto.title || '',
      erpId: dto.erpId,
      erpType: dto.erpType,
      priceChannel: dto.priceChannel,
      mgPrisVersion: dto.mgPrisVersion,
      sendSalesPriceUpdated: dto.sendSalesPriceUpdated,
      totalfilFormat: dto.totalfilFormat,
      totalfilCharset: dto.totalfilCharset,
      totalfilPerSupplier: dto.totalfilPerSupplier,
      totalfilToSftp: dto.totalfilToSftp,
      totalfilSftpDirectory: dto.totalfilSftpDirectory,
      totalfilSftpFrequency: dto.totalfilSftpFrequency,
      totalfilNumberOfFutureDays: dto.totalfilNumberOfFutureDays,
      totalfilVilmaVersion: dto.totalfilVilmaVersion,
      locations: dto.locations ? dto.locations.map(LocationConfig.fromDto) : [],
    });
}
